// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__jkoF7","rootCenter":"LoadMoreObserver_rootCenter__1ViX2","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1e7pP"};